import { Config } from "../environment/config";
import { Env } from "@emed/virtual-lab-models";
import { CDNUtils } from "./CDNUtils";

export class ProcedureScriptUtils {
	private static envOptions: Env.Options;

	private static async getEnvOptions() {
		if (!this.envOptions) {
			const env = await CDNUtils.loadFileFromCDN("/public-environment.json");
			this.envOptions = new Env.Options(env);
		}
		return this.envOptions;
	}

	public static async resolveScriptPath(procedure: string) {
		if (typeof procedure !== "string" || !procedure) {
			throw new Error(`Failed to resolve script path for procedure: ${procedure}`);
		}
		const envOptions = await this.getEnvOptions();

		const redirectMap = envOptions.get(Config.VLAB_PROCEDURE_MAP, { optional: true });

		if (redirectMap && Object.keys(redirectMap).length > 0 && redirectMap[procedure]) {
			return redirectMap[procedure];
		}
		return procedure;
	}

	public static async resolveScriptName(procedure: string) {
		if (typeof procedure !== "string" || !procedure) {
			throw new Error(`Failed to resolve script name for procedure: ${procedure}`);
		}
		const resolvedPath = await this.resolveScriptPath(procedure);
		if (typeof resolvedPath !== "string") {
			throw new Error(`Failed to resolve script name for procedure: ${procedure}`);
		}
		const segments = resolvedPath.split("/");
		return segments[0];
	}

	public static async resolveScriptVersion(procedure: string) {
		const resolvedPath = await this.resolveScriptPath(procedure);

		const segments = resolvedPath.split("/");

		return segments.length === 1 ? "v1" : segments[1];
	}
}
